import Box from '@redbubble/design-system/src/Box';
import Button from '@redbubble/design-system/src/Button';
import * as constants from '@redbubble/design-system/src/constants';
import CloseIcon from '@redbubble/design-system/src/Icons/Close';
import { Sheet } from '@redbubble/design-system/src/Sheets';
import { useIntl } from '@redbubble/next/intl';
import { useNavigation } from '@redbubble/next-provider';
import styles from './Filters.module.scss';
import { useFiltersContext } from './FiltersContext';
import { messages } from './messages';

interface FilterSheetProps {
  title: string;
  openSheet?: () => void;
  close: () => void;
  children: React.ReactNode;
  goBack?: () => void;
  onClose: () => void;
  useAnimations?: boolean;
}

export const FilterSheet = ({
  title,
  goBack,
  close,
  openSheet,
  children,
  onClose,
  useAnimations,
}: FilterSheetProps) => {
  const intl = useIntl();
  const { navigate } = useNavigation();
  const { pathWithQueryString } = useFiltersContext();
  const sheetTabTitles = [
    intl.formatMessage(messages.product),
    intl.formatMessage(messages.filters),
  ];

  const getResults = () => {
    navigate({ url: pathWithQueryString });
    onClose();
  };

  return (
    <Sheet hideTitleBar useAnimations={useAnimations}>
      <Box className={styles.filtersContainer} data-testid="filtersContainer">
        <Box className={styles.filtersTabbedTitles} padding="m">
          {sheetTabTitles.map((tabName) => {
            const currentTab = title === tabName;
            return (
              <Box
                key={tabName}
                className={[
                  styles.tabTitle,
                  !currentTab && styles.clickableTab,
                ].join(' ')}
                onClick={() => {
                  if (!currentTab) {
                    if (goBack) goBack();
                    if (openSheet) openSheet();
                  }
                }}
                data-testid={currentTab ? 'active-tab' : 'inactive-tab'}
              >
                <span className={currentTab ? styles.activeTab : ''}>
                  {tabName}
                </span>
              </Box>
            );
          })}
          <Box
            className={styles.icon}
            onClick={close}
            data-testid="close-drawer-button"
          >
            <span className={styles.closeText}>
              {intl.formatMessage(messages.close)}
            </span>
            <CloseIcon size={constants.MEDIUM} />
          </Box>
        </Box>
        <div>{children}</div>
        <Box className={styles.viewResults} padding="m">
          <Button
            intent={constants.PRIMARY}
            strong
            fluid
            onClick={getResults}
            size={constants.LARGE}
          >
            {intl.formatMessage(messages.viewResults)}
          </Button>
        </Box>
      </Box>
    </Sheet>
  );
};
